import React from 'react';
import PropTypes from 'prop-types';
// import { withStyles } from "@material-ui/core/styles";
import { TableCell as MuiTableCell } from '@material-ui/core';

const TableCell = ({
  children,
  classes,
  data,
  numeric,
  padding,
  type,
  sortDirection,
  width,
  onClick,
  onHeaderClick,
}) => {
  function handleClick(event) {
    if (type === 'body') onClick(data);
    if (onHeaderClick) onHeaderClick(event);
  }

  return (
    <MuiTableCell
      classes={classes}
      variant={type} // enum: "head" || "body" || "footer"
      align={numeric ? 'right' : 'left'} // boolean
      style={{
        width,
        padding,
        verticalAlign: type === 'body' && 'inherit',
        wordWrap: 'break-word',
      }}
      sortDirection={sortDirection}
      onClick={(e) => handleClick(e)}>
      {children}
    </MuiTableCell>
  );
};

TableCell.defaultProps = {
  classes: {},
  data: {},
  numeric: false,
  padding: '8px',
  type: 'body',
  sortDirection: false,
  width: '100px',
  onClick: () => {},
  onHeaderClick: () => {},
};

TableCell.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object,
  data: PropTypes.object,
  numeric: PropTypes.bool,
  padding: PropTypes.string,
  type: PropTypes.oneOf(['head', 'body', 'footer']),
  sortDirection: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  width: PropTypes.string,
  onClick: PropTypes.func,
  onHeaderClick: PropTypes.func,
};

export default TableCell;
